'use client'

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from '@/components/ui/empty'
import { Metadata } from 'next'

export default function Error() {
  return (
    <div className='h-dvh flex items-center justify-center'>
      <Empty>
        <EmptyHeader>
          <p className='text-[25vw] sm:text-[14rem] font-black bg-linear-60 to-indigo-500 from-violet-400 bg-clip-text text-transparent animate-tada'>
            ERROR
          </p>
          <EmptyTitle>Ha ocurrido un error en la aplicación</EmptyTitle>
          <EmptyDescription>
            Si el error persiste, por favor contacta al administrador del
            sistema.
          </EmptyDescription>
          <EmptyDescription>areasclinicas@ugma.edu.ve</EmptyDescription>
        </EmptyHeader>
      </Empty>
    </div>
  )
}

export const metadata: Metadata = {
  title: 'Error - UGMA Odontología',
}
